import { Link } from 'react-router-dom';

function Privacy() {
  return (
    <>
      {/* Page Hero */}
      <section className="page-hero" style={{ backgroundImage: 'linear-gradient(rgba(8, 50, 62, 0.85), rgba(8, 50, 62, 0.85)), url(/images/hero_home.png)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="container">
          <div className="eyebrow" style={{ color: 'var(--gold-light)' }}>Legal Information</div>
          <h1>Privacy Policy</h1>
          <p>How we collect, use, store, and safeguard your personal information.</p>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="sep">›</span>
            <span className="current">Privacy Policy</span>
          </div>
        </div>
      </section>

      <section className="section-pad" style={{ background: 'var(--white)' }}>
        <div className="container" style={{ maxWidth: '800px', lineHeight: '1.7', color: 'var(--muted)' }}>
          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>1. Introduction</h3>
          <p style={{ marginBottom: 24 }}>
            Mega Health Group (Mega Hospital Foundation) is committed to protecting the privacy and confidentiality of all patients, visitors, and users of our website. This Privacy Policy explains how we collect, use, store, and safeguard your personal information.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>2. Information We Collect</h3>
          <p style={{ marginBottom: 12 }}>We may collect the following types of information:</p>
          <ul style={{ marginBottom: 24, paddingLeft: 24 }}>
            <li>Personal details such as name, age, gender, contact number, and email address</li>
            <li>Medical and health-related information provided for treatment or diagnostic purposes</li>
            <li>Appointment and registration details</li>
            <li>Insurance and billing information</li>
            <li>Information submitted through website forms or inquiries</li>
          </ul>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>3. How We Use Your Information</h3>
          <p style={{ marginBottom: 12 }}>We use your information for the following purposes:</p>
          <ul style={{ marginBottom: 24, paddingLeft: 24 }}>
            <li>To provide medical consultation, diagnosis, and treatment services</li>
            <li>To manage appointments and patient records</li>
            <li>To process billing and insurance claims</li>
            <li>To communicate important updates related to your healthcare</li>
            <li>To improve our services and patient experience</li>
            <li>To comply with legal and regulatory requirements</li>
          </ul>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>4. Data Confidentiality</h3>
          <p style={{ marginBottom: 24 }}>
            All patient information is treated as strictly confidential. We do not sell, rent, or share your personal data with third parties, except when required for treatment, insurance processing, or by law.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>5. Data Security</h3>
          <p style={{ marginBottom: 24 }}>
            We implement appropriate technical, administrative, and physical safeguards to protect your personal and medical data against unauthorized access, alteration, disclosure, or misuse.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>6. Use of Diagnostic & Laboratory Data</h3>
          <p style={{ marginBottom: 24 }}>
            All pathology and diagnostic data collected through our facilities, including Mega Lab & Digno Research Center, is used solely for medical purposes and is securely stored as per standard healthcare practices.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>7. Cookies & Website Tracking</h3>
          <p style={{ marginBottom: 24 }}>
            Our website may use cookies or similar technologies to improve user experience and analyze website traffic. Users may choose to disable cookies in their browser settings.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>8. Third-Party Services</h3>
          <p style={{ marginBottom: 24 }}>
            We may use trusted third-party service providers (such as laboratories, insurance partners, or payment gateways) to support healthcare services. These partners are required to maintain confidentiality and data protection standards.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>9. Patient Rights</h3>
          <p style={{ marginBottom: 12 }}>Patients have the right to:</p>
          <ul style={{ marginBottom: 24, paddingLeft: 24 }}>
            <li>Access their medical records</li>
            <li>Request corrections to inaccurate information</li>
            <li>Request information about how their data is used</li>
            <li>Withdraw consent where applicable, subject to legal and medical requirements</li>
          </ul>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>10. Children's Privacy</h3>
          <p style={{ marginBottom: 24 }}>
            We take special care when handling information related to children. Data is collected only with the consent of parents or legal guardians.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>11. Changes to This Policy</h3>
          <p style={{ marginBottom: 24 }}>
            Mega Health Group reserves the right to update this Privacy Policy at any time. Updates will be posted on this page with the revised date.
          </p>

          <h3 style={{ color: 'var(--teal-dark)', marginBottom: 12 }}>12. Contact Us</h3>
          <p style={{ marginBottom: 24 }}>
            If you have any questions regarding this Privacy Policy or how your information is handled, please contact us through our official hospital contact details.
          </p>
        </div>
      </section>
    </>
  );
}

export default Privacy;
